module.exports = __webpack_public_path__ + "static/media/game(1).72986121.PNG";